import { useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { useAppDispatch } from 'hooks/useRedux';
import { workflowActions } from 'state/workflow';
import FormWrapper from 'components/FormWrapper/FormWrapper';
import { Button } from 'react-bootstrap';
import { XMarkThinIcon } from 'assets/icons/XMarkThinIcon';

const UnsignedPrescription = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(workflowActions.setLoading(false));
  }, []);

  const onCompletePrescriptionClick = () => {
    dispatch(workflowActions.setLoading(true));
    dispatch(
      workflowActions.workflowNextStep({
        option: 'relaunch_rcopia',
      }),
    );
  };

  const onCancelTransactionClick = async () => {
    dispatch(workflowActions.setLoading(true));
    dispatch(
      workflowActions.workflowNextStep({
        option: 'cancel_transaction',
      }),
    );
  };

  return (
    <>
      <FormWrapper text="Complete Prescription">
        <div className="row">
          <div className="col-12">
            <h5 className="fw-bold my-2">
              Your prescription is still pending and has not been sent to the pharmacy
            </h5>
            <div className="col-12 mt-4 d-flex flex-md-row flex-column-reverse gap-2 mb-4">
              <Button
                id="cancel-transaction-button"
                onClick={onCancelTransactionClick}
                className="px-3 rounded-pill btn-purple-outline fw-bold d-flex justify-content-center"
                size="sm"
              >
                <div className="d-flex flex-row align-items-center gap-2">
                  Cancel Transaction
                  <XMarkThinIcon />
                </div>
              </Button>
              <Button
                variant="danger"
                className="px-3 rounded-pill fw-bold d-flex justify-content-center"
                onClick={onCompletePrescriptionClick}
                size="sm"
              >
                <div className="d-flex flex-row align-items-center gap-2">
                  Complete Prescription
                  <FontAwesomeIcon
                    icon={faArrowRight}
                    size="xs"
                  />
                </div>
              </Button>
            </div>
          </div>
        </div>
      </FormWrapper>
    </>
  );
};

export default UnsignedPrescription;
